<template>
  <div id="app">
    <div class="full-width py-6"
    :class="{ 'bg-white': isRouteDetailsActive, 'text-dark': isRouteDetailsActive, 'bg-secondary': !isRouteDetailsActive }">

        <router-view></router-view>

      <!--
      Cannot get the router-view transition to work!
      <transition name="fade">
        <router-view></router-view>
      </transition> -->

    </div>
  </div>
</template>
<script>
import mixinCommon from './mixins/common'

// set global isFuture
window.showFutureRoutes = true

export default {
  name: 'app',
  mixins: [mixinCommon],
  computed: {
    isRouteDetailsActive () {
      return Boolean(this.$route.name === 'routes-all'
                    && this.$route.params.routeNo !== 'undefined'
                    && this.$route.params.routeNo.length > 0);
    }
  },
  mounted () {
    // only called once throughout the entire app here
    this.$store.dispatch('geoLocation/getCurrentGeoLocation', {})
  }
 }
</script>
<style lang="scss">
@import 'assets/icomoon/style.css'; // must be disabled when building for production
@import 'sass/app.scss'; // must be disabled when building for production

.container {
  // border:solid 1px #000;
}
.container-mobile {
  padding-left: 0;
  padding-right: 0;
}
#app {
  // font-family: 'Avenir', Helvetica, Arial, sans-serif;
  // -webkit-font-smoothing: antialiased;
  // -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  // color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue